import React from "react";
import { useState, useEffect, useContext } from "react";
import Modal from "@/components/Modal";

import { Document, Page, pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { ElementProps } from "@/types/elements";
import { useModal } from "@/lib/hooks/useModal";
import clsx from "clsx";

export default function PDFElement({block: { id: blockId, data }, viewMode, tracer, appearance }: ElementProps) {

    data['link'] = data['link'].replace('https://firebasestorage.googleapis.com/v0/b/curious-page.appspot.com', '/storage')
    data['link'] = data['link'].replace('https://firebasestorage.googleapis.com:443/v0/b/curious-page.appspot.com', '/storage')

    const Viewer = () => {
        const [numPages, setNumPages] = useState(1);
        const [pageNumber, setPageNumber] = useState(1);

        interface onDocumentLoadSuccess {
            numPages: number;
        }
        function onDocumentLoadSuccess({ numPages }: onDocumentLoadSuccess) {
            setNumPages(numPages);
        }

        return <Document
            file={data['link']}
            onLoadSuccess={onDocumentLoadSuccess}>
            {
                Array.from(
                    new Array(numPages),
                    (el, index) => (
                        <Page
                            key={`page_${index + 1}`}
                            pageNumber={index + 1}
                        />
                    ),
                )
            }
        </Document>
    };

    const { openModal } = useModal(); 

    const showPDFModal = () => {
        openModal(<Viewer />, data['title'])
    }

    return (
        <>
            <div className={clsx("flex flex-col bg-white border shadow-lg", appearance?.corner === 'square' ? 'rounded-none' : 'rounded-lg')}>
                <figure className="relative w-full">
                    <img onClick={() => {
                        showPDFModal()
                        tracer?.trackClick({ blockId, meta: { action: 'view' } })
                    }} className={clsx("cursor-pointer rounded-t-lg w-full object-cover shadow-xl hover:shadow-2xl image-item h-[25vh]", viewMode ? "md:h-[40vh]" : "")}
                        style={{ objectPosition: '0  0' }}
                        src={data['cover']} alt={data['title']} />
                    <span className="absolute top-0 left-0 p-3 text-gray-500">
                        <img src="/images/pdf2.png" className="w-6" />
                    </span>
                </figure>
                <div className={clsx('flex justify-between flex-col py-3 px-4 space-y-2', viewMode ? 'md:flex-row md:space-y-0 md:items-center' : '')}>
                    <div>
                        <span className="text-sm md:text-md" style={{ fontFamily: 'InterRegular' }}>
                            {data['title']}
                        </span>
                    </div>
                    <div className={'flex md:flex-row space-x-3 my-auto text-sm md:text-md'} style={{ fontFamily: 'InterRegular' }}>
                        <span onClick={() => showPDFModal()} className={'flex flex-row cursor-pointer noselect justify-center text-center my-auto bg-gray-100 rounded-2xl px-3 py-1 hover:bg-gray-200 space-x-1'}>
                            <svg style={{ marginTop: '2px' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                                strokeLinejoin="round" className="feather feather-book-open"><path
                                    d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12"
                                        r="3" />
                            </svg>
                            <p>View</p>
                        </span>
                        {data['downloadable'] &&
                            <span onClick={() => tracer?.openLink({ blockId, link: data['link'], meta: { action: 'download' } })} className={'flex flex-row cursor-pointer noselect justify-center text-center my-auto bg-gray-100 rounded-2xl px-3 py-1 hover:bg-gray-200 space-x-1'}>
                                <svg style={{ marginTop: '2px' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                                    strokeLinejoin="round" className="feather feather-download"><path
                                        d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline
                                        points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12"
                                            y2="3" />
                                </svg>
                                <p className="hidden md:flex">Download</p>
                            </span>}
                    </div>

                </div>
            </div>
        </>
    )
}
